module.exports = __webpack_public_path__ + "static/media/Brookstone-Village-HOA-By-Laws.14544849.pdf";